export default __webpack_public_path__ + "static/media/pr_c_05.b92efbb7.jpg";